import { Row } from 'hatch-components';
import styled from 'styled-components';

export const StyledNotifications = styled(Row)(
  ({ type, transition, theme: { spacing, colors } }) => ({
    background: type === 'success' ? colors.success : colors.primaryTint,
    bottom: 0,
    cursor: 'pointer',
    flexWrap: 'nowrap',
    justifyContent: 'space-between',
    left: 0,
    opacity: transition === 'entered' ? 1 : 0,
    padding: `${spacing.sm} 36px ${spacing.sm} ${spacing.sm}`,
    position: 'fixed',
    transform: transition === 'entered' ? 'translateY(0)' : 'translateY(84px)',
    transition: 'all 0.5s ease',
    width: '100%',
    zIndex: 9999,
  }),
);

export const StyledNotificationMessage = styled.p(
  ({ theme: { font, colors } }) => ({
    color: colors.white,
    fontSize: font.size.sm,
    lineHeight: font.lineHeight.sm,
    overflow: 'hidden',
    width: '100%',
  }),
);

export const StyledCloseNotification = styled.small(
  ({ theme: { spacing, colors, font } }) => ({
    color: colors.white,
    fontSize: font.size.lg,
    lineHeight: 1,
    marginTop: '-10.5px',
    position: 'absolute',
    right: spacing.sm,
    top: '50%',
  }),
);
